import UserApi from '@/frontend/api/user';
import { ElLoading, ElMessage } from 'element-plus';
export default {
  name: "VerifyEmailPage",

  data() {
    return {
      error: undefined
    };
  },

  created() {
    let loader = ElLoading.service({
      lock: false,
      text: 'Загрузка'
    });
    UserApi.verifyEmail({
      token: this.$route.params.token
    }).then(() => this.error = false).catch(error => {
      if (error instanceof String) {
        this.error = error;
        return;
      }

      ElMessage.error('Неизвестная ошибка!');
      console.error(error);
    }).finally(() => loader.close());
  }

};